@if (!to.ynAsync) {
  <div>
    <mat-radio-group [formControl]="formControl" class="radio-group">
      <small>{{ to.label | translate }}</small>
      @for (option of to.options; track option) {
        <mat-radio-button class="radio-button" [value]="option.key">
          &nbsp;{{ option.value | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
}

@if (to.ynAsync) {
  <div>
    @if (to.options | async; as options) {
      <mat-radio-group [formControl]="formControl" class="radio-group">
        <small>{{ to.label | translate }}</small>
        @for (option of options; track option) {
          <mat-radio-button class="radio-button" [value]="option.key">
            &nbsp;{{ option.value | translate }}
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  </div>
}